import { toast } from "sonner";
import { Download, Copy, Share2 } from "lucide-react";

const SITE_URL = "https://wardensurveillance.com";

export function ShareScore({ scanId, host, score, showHeader = true }) {
  const cardUrl = `${process.env.REACT_APP_BACKEND_URL}/api/scans/${scanId}/score-card.png`;
  const text = `My website ${host} scored ${score}/100 on Warden's free AI security scan 🛡️ Check your site's Security Score:`;
  const enc = encodeURIComponent;

  const links = {
    x: `https://twitter.com/intent/tweet?text=${enc(text)}&url=${enc(SITE_URL)}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${enc(SITE_URL)}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${enc(SITE_URL)}&quote=${enc(text)}`,
  };

  const open = (url) => window.open(url, "_blank", "noopener,width=640,height=560");
  const copyLink = () => { navigator.clipboard.writeText(SITE_URL); toast.success("Link copied — paste it anywhere!"); };

  const btn = "flex items-center gap-1.5 text-sm px-3 py-2 rounded-md border border-slate-700 hover:border-cyanbrand text-slate-200 hover:text-white transition-colors";

  return (
    <div className={showHeader ? "mt-6 pt-5 border-t border-slate-800" : "mt-2"} data-testid="share-score">
      {showHeader && (
        <div className="flex items-center gap-2 mb-3 text-slate-300">
          <Share2 size={16} className="text-cyanbrand" />
          <span className="text-sm font-semibold">Share your Security Score</span>
        </div>
      )}
      <div className="flex flex-wrap gap-2">
        <a
          href={cardUrl} target="_blank" rel="noopener noreferrer" download
          data-testid="share-download-card"
          className="flex items-center gap-1.5 text-sm px-3 py-2 rounded-md bg-cyanbrand hover:bg-[#00B8D9] text-slate-900 font-semibold transition-all"
        >
          <Download size={15} /> Download card
        </a>
        <button onClick={() => open(links.x)} data-testid="share-x" className={btn}>Post on X</button>
        <button onClick={() => open(links.linkedin)} data-testid="share-linkedin" className={btn}>LinkedIn</button>
        <button onClick={() => open(links.facebook)} data-testid="share-facebook" className={btn}>Facebook</button>
        <button onClick={copyLink} data-testid="share-copy" className={btn}><Copy size={15} /> Copy link</button>
      </div>
    </div>
  );
}
